import { ApexApiError } from '@Types'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getCountries } from '../api'
import { TEMPORARILY_UNAVAILABLE } from './constants'
import { GET_COUNTRIES, GET_COUNTRIES_FAILURE, GET_COUNTRIES_SUCCESS } from '../reducers/countryReducer'

export const getCountryList = (dispatch: Dispatch) => {
  dispatch({ type: GET_COUNTRIES })
  getCountries()
    .then((response: AxiosResponse) => {
      const { data } = response
      dispatch({
        type: GET_COUNTRIES_SUCCESS,
        countryList: data.countries
      })
    })
    .catch((error: ApexApiError) => {
      const errorMessage = TEMPORARILY_UNAVAILABLE
      dispatch({ type: GET_COUNTRIES_FAILURE, countryListFailedMessage: errorMessage })
    })
}
